import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { DadosBasicosPrestadorModel } from "@/models/cadastros/saude/DadosBasicosPrestadorModel";
import { EspecialidadePrestadorModel } from "@/models/cadastros/saude/EspecialidadePrestadorModel";
import { ProfissionalModel } from "@/models/cadastros/saude/ProfissionalModel";

export interface IPrestadorSaudeStore extends VuexModule {
  dadosBasicosPrestador: DadosBasicosPrestadorModel | null;
  especialidadePestador: EspecialidadePrestadorModel[] | null;
  profissionais: ProfissionalModel[] | null;
}

const getDefaultState = () => {
  return {
    dadosBasicosPrestador: null,
    especialidadePestador: null,
    profissionais: null,
  };
};

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "PrestadorSaude",
})
class PrestadorSaudeStore extends VuexModule implements IPrestadorSaudeStore {
  dadosBasicosPrestador: DadosBasicosPrestadorModel | null = null;
  especialidadePestador: EspecialidadePrestadorModel[] | null = null;
  profissionais: ProfissionalModel[] | null = null;

  @Mutation
  RESET() {
    Object.assign(this, getDefaultState());
  }

  @Mutation
  SET_DADOS_BASICOS(payload: DadosBasicosPrestadorModel) {
    this.dadosBasicosPrestador = payload;
  }
}

export const prestadorSaudeStore = getModule(PrestadorSaudeStore);
